import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * AccordionComponent - Container for accordion items
 *
 * Provides styling context for multiple AccordionItemComponent children.
 * Unlike traditional accordions, this allows multiple items to be open simultaneously.
 *
 * @example
 * ```html
 * <zag-accordion>
 *   <zag-accordion-item [title]="'Section 1'" [icon]="'home'">
 *     Content for section 1
 *   </zag-accordion-item>
 *   <zag-accordion-item [title]="'Section 2'" [icon]="'settings'">
 *     Content for section 2
 *   </zag-accordion-item>
 * </zag-accordion>
 * ```
 */
@Component({
  selector: 'zag-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="zag-accordion">
      <ng-content />
    </div>
  `,
  styles: [
    `
      .zag-accordion {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-md, 1rem);
      }
    `,
  ],
})
export class AccordionComponent {}
